import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from "../../../graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";

export const DELETE_REPORT_FILE = gql`
    mutation ($clientReportFileGuid: UUID! ){
        removeClientReportFile(clientReportFileGuid: $clientReportFileGuid)
    }
`;

type DeleteReportFileInput = {
    clientReportFileGuid: string,
}

export const useDeleteReportFile = (
    successCallback: () => void,
) => {
    const {
        isRunning$,
        execute,
    } = useMutation$<DeleteReportFileInput, void>(DELETE_REPORT_FILE);

    const removeClientReportFile = useCallback(async (clientReportFileGuid: string, clientReportFileName: string) => {
        try {
            const {data: result,} = await execute({
                variables: {
                    clientReportFileGuid: clientReportFileGuid
                }
            });
            if (result) {
                successCallback();
                showToast.success(`The report file ${clientReportFileName} was successfully deleted.`);
            }
        } catch (e: any) {
            showToast.error(getDomainGraphqlError(e) ?? `Unable to delete the report file ${clientReportFileName}: ${e.message || e[0].message}`);
        }
    }, [execute, successCallback]);


    return {
        isRunning$,
        execute: removeClientReportFile,
    };
};
